// import { Language } from '../../services/literals-service'
import { IBase, IDocument, INotificationPreference, IPaymentGateway } from '../../models'
import { ICountry } from '../../models/country'
import {
  IChangeConfirmationFlagAction,
  ISetNotificationFeedbackFlagAction,
  IChangeUserLanguageAction,
  ICheckSessionAction,
  IDeleteDocumentAction,
  IFetchDocumentsAction,
  ISaveUserInfoAction,
  ISaveUserLanguageAction,
  ISetAccountId,
  ISetDocumentsAction,
  ISetGuestModeAction,
  IShowGuestSignUpAction,
  IHideGuestSignUpAction,
  ISetGuestSignUpScreenAction,
  GuestSignUpScreen,
  ISetIsLoadingUserInfoAction,
  ISetIsUserExperienced,
  ISetIsUserPenalizedAction,
  ISetPaymentGatewayAction,
  ISetPaymentMethodId,
  ISetStripeCustomerIds,
  ISetUserInfoAction,
  ISetUserInfoAdditionalPhoneAction,
  ISetUserInfoAdditionalPhoneCallingCodeAction,
  ISetUserInfoAdditionalPhoneCountryAction,
  ISetUserInfoBirthDayAction,
  ISetUserInfoBirthMonthAction,
  ISetUserInfoBirthYearAction,
  ISetUserInfoDNIAction,
  ISetUserInfoEmailAction,
  ISetUserInfoGenderAction,
  ISetUserInfoIsPrmAction,
  ISetUserInfoLastNameAction,
  ISetUserInfoNameAction,
  ISetUserInfoSettlementAction,
  IUploadDocumentAction,
  UserInfoTypeKeys
} from '../types'

export function checkSessionAction(): ICheckSessionAction {
  return { type: UserInfoTypeKeys.CHECK_USER }
}

export function setGuestModeAction(): ISetGuestModeAction {
  return { type: UserInfoTypeKeys.SET_GUEST_MODE }
}

// A guest tried something that needs an account: offer to create one (or sign in).
export function showGuestSignUpAction(screen: GuestSignUpScreen = 'intro'): IShowGuestSignUpAction {
  return { type: UserInfoTypeKeys.SHOW_GUEST_SIGN_UP, payload: screen }
}

// Moves the open prompt to another of its screens; the sagas use it instead of routing when the
// prompt is what the user is looking at.
export function setGuestSignUpScreenAction(screen: GuestSignUpScreen): ISetGuestSignUpScreenAction {
  return { type: UserInfoTypeKeys.SET_GUEST_SIGN_UP_SCREEN, payload: screen }
}

export function hideGuestSignUpAction(): IHideGuestSignUpAction {
  return { type: UserInfoTypeKeys.HIDE_GUEST_SIGN_UP }
}

export function setUserInfoAction(userInfo: any): ISetUserInfoAction {
  return { type: UserInfoTypeKeys.SET_USER_INFO, payload: userInfo }
}

export function setUserInfoDNIAction(dni: string): ISetUserInfoDNIAction {
  return { type: UserInfoTypeKeys.SET_USER_INFO_DNI, payload: dni }
}

export function setUserInfoEmailAction(email: string): ISetUserInfoEmailAction {
  return { type: UserInfoTypeKeys.SET_USER_INFO_EMAIL, payload: email }
}

export function setUserInfoNameAction(name: string): ISetUserInfoNameAction {
  return { type: UserInfoTypeKeys.SET_USER_INFO_NAME, payload: name }
}

export function setUserInfoLastNameAction(lastName: string): ISetUserInfoLastNameAction {
  return { type: UserInfoTypeKeys.SET_USER_INFO_LAST_NAME, payload: lastName }
}

export function setUserInfoBirthDayAction(day: string): ISetUserInfoBirthDayAction {
  return { type: UserInfoTypeKeys.SET_USER_INFO_BIRTH_DAY, payload: day }
}

export function setUserInfoBirthMonthAction(month: string): ISetUserInfoBirthMonthAction {
  return { type: UserInfoTypeKeys.SET_USER_INFO_BIRTH_MONTH, payload: month }
}

export function setUserInfoBirthYearAction(year: string): ISetUserInfoBirthYearAction {
  return { type: UserInfoTypeKeys.SET_USER_INFO_BIRTH_YEAR, payload: year }
}

export function setUserInfoGenderAction(gender: string): ISetUserInfoGenderAction {
  return { type: UserInfoTypeKeys.SET_USER_INFO_GENDER, payload: gender }
}

export function setUserInfoIsPrmAction(isPrm: boolean): ISetUserInfoIsPrmAction {
  return { type: UserInfoTypeKeys.SET_USER_INFO_IS_PRM, payload: isPrm }
}

export function setUserInfoSettlementAction(settlement: string): ISetUserInfoSettlementAction {
  return { type: UserInfoTypeKeys.SET_USER_INFO_SETTLEMENT, payload: settlement }
}

export function setUserInfoAdditionalPhoneAction(phone: string): ISetUserInfoAdditionalPhoneAction {
  return { type: UserInfoTypeKeys.SET_USER_INFO_ADDITIONAL_PHONE, payload: phone }
}

export function setUserInfoAdditionalPhoneCallingCodeAction(
  callingCode: string
): ISetUserInfoAdditionalPhoneCallingCodeAction {
  return { type: UserInfoTypeKeys.SET_USER_INFO_ADDITIONAL_PHONE_CALLING_CODE, payload: callingCode }
}

export function setUserInfoAdditionalPhoneCountryAction(country: ICountry): ISetUserInfoAdditionalPhoneCountryAction {
  return { type: UserInfoTypeKeys.SET_USER_INFO_ADDITIONAL_PHONE_COUNTRY, payload: country }
}

export function saveUserInfoAction(notificationPreferences?: INotificationPreference[]): ISaveUserInfoAction {
  return { type: UserInfoTypeKeys.SAVE_USER_INFO, payload: notificationPreferences }
}
export function saveUserLanguageAction(locale: string): ISaveUserLanguageAction {
  return { type: UserInfoTypeKeys.SAVE_USER_LANGUAGE, payload: locale }
}

export function changeUserLanguageAction(lenguage: string): IChangeUserLanguageAction {
  return { type: UserInfoTypeKeys.CHANGE_USER_LENGUAGE, payload: lenguage }
}

export function changeConfirmationFlagAction(): IChangeConfirmationFlagAction {
  return { type: UserInfoTypeKeys.CHANGE_CONFIRMATION_FLAG }
}

export function setNotificationFeedbackFlagAction(enabled: boolean): ISetNotificationFeedbackFlagAction {
  return { type: UserInfoTypeKeys.SET_NOTIFICATION_FEEDBACK_FLAG, payload: enabled }
}

export function setIsUserPenalizedAction(): ISetIsUserPenalizedAction {
  return { type: UserInfoTypeKeys.SET_IS_USER_PENALIZED }
}

export function setIsLoadingUserInfoAction(loading: boolean): ISetIsLoadingUserInfoAction {
  return { type: UserInfoTypeKeys.IS_LOADING_USER_INFO, payload: loading }
}

export function setIsUserExperienced(payload: boolean): ISetIsUserExperienced {
  return { type: UserInfoTypeKeys.SET_IS_USER_EXPERIENCED, payload }
}

export function setPaymentMethodId(payload: string): ISetPaymentMethodId {
  return { type: UserInfoTypeKeys.SET_PAYMENT_METHOD_ID, payload }
}

export function setStripeCustomerIds(payload: any[]): ISetStripeCustomerIds {
  return { type: UserInfoTypeKeys.SET_STRIPE_CUSTOMER_IDS, payload }
}

export function setStripeAccountId(payload: string | null): ISetAccountId {
  return { type: UserInfoTypeKeys.SET_ACCOUNT_ID, payload: payload ?? '' }
}

export function setPaymentGatewayAction(payload: IPaymentGateway): ISetPaymentGatewayAction {
  return { type: UserInfoTypeKeys.SET_PAYMENT_GATEWAY, payload }
}

export function setDocumentsAction(documents: IDocument[]): ISetDocumentsAction {
  return { type: UserInfoTypeKeys.SET_DOCUMENTS, payload: documents }
}

export function fetchDocumentsAction(): IFetchDocumentsAction {
  return { type: UserInfoTypeKeys.FETCH_DOCUMENTS }
}

export function uploadDocumentAction(image: string, type: string, fileName: string): IUploadDocumentAction {
  return { type: UserInfoTypeKeys.UPLOAD_DOCUMENT, payload: { image, type, fileName } }
}

export function deleteDocumentAction(id: number): IDeleteDocumentAction {
  return { type: UserInfoTypeKeys.DELETE_DOCUMENT, payload: id }
}